import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map/map.component';
import { ElectionMapComponent } from './election-map/election-map.component';
import { MapLegendComponent } from './map-legend/map-legend.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MapComponent,
    ElectionMapComponent,
    MapLegendComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    ElectionMapComponent
  ]
})
export class MapModule { }
